import { render, staticRenderFns } from "./DetailWeb.vue?vue&type=template&id=08162a40&scoped=true"
import script from "./DetailWeb.vue?vue&type=script&lang=js"
export * from "./DetailWeb.vue?vue&type=script&lang=js"
import style0 from "./DetailWeb.vue?vue&type=style&index=0&id=08162a40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08162a40",
  null
  
)

export default component.exports